'use strict'

module.exports = {
 'title': 'Socceroos 2024 Asian Cup QF',
 'name': 'Socceroos2024AsianCupQF',
 'assetPath': {
  'development': 'https://nca1030283/nnd/',
  'staging': 'https://d2n6ofw4o746cn.cloudfront.net/nnd/data/tester/',
  'production': 'https://d2n6ofw4o746cn.cloudfront.net/nnd/'
 },
 'deployPath': {
  'development': '../../../nnd/',
  'staging': '../../tester/',
  'production': '../../nnd/'
 }
}



//////////////////
// WEBPACK FOOTER
// ./project.js
// module id = wrBJ
// module chunks = 1